
import img0 from './Images/RegisterApplication.png';
import img1 from './Images/NewClientSecret.png';
import img2 from './Images/AddRoleAssignmentForKeyVault.png';
import img3 from './Images/KeyVaultFirewall.png';
import img4 from './Images/CustomKeyVaultConfigure.png';
  
const content = `# Custom Key Vault

By default, an organization's encryption keys are stored in OnData's key vault, which is hosted in the Azure Government cloud platform. If desired, an organization can use 
its own key vault to store its encryption keys. Such encryptions keys are either used for data encryption or key encryption. The purpose of this document is to illustrate 
how to configure a custom key vault to store an organization's encryption keys. Currently the custom key vault can only be hosted in Azure Global or Azure Government 
cloud platform. The support for other cloud platforms will be made available in future.  
  
**Important Note**: If a custom key vault is enabled, the configured key vault SHOULD NOT BE DELETED. Otherwise, the encrypted data or keys will no longer be available.
  
## Configuring Custom Key Vault in Azure Global or Azure Government
Please follow the steps below to configure a custom key vault in either Azure Global or Azure Government cloud platforms.  
  
### Step 1: Add Service Principal
a. Sign into the Azure Portal, browse to **App registrations** and click on the **New registration** button.  
  
b. Enter a name for the application and leave the other options as default, then click on the **Register** button to register a new application.  
  
   ![Register Application](${ img0 })  
  
c. After the new application is created, go to the details page for that application. On the left menu select **Manage** -> **Certificates & secrets**, and click on 
**New client secret** under the **Client secrets** tab to add a new client secret. **Note**: Please copy and save the value of the client secret immediately after 
creation. The value is not accessible after you leave the page.  
  
   ![New Client Secret](${ img1 })  
  
d. On the left menu select **Overview**, and save the values of **Directory (tenant) ID** and **Application (client) ID** for later use.  
  
### Step 2: Add Key Vault
a. Sign into the Azure Portal, browse to **Key vaults** and click on **Create** to create a new key vault.  
  
b. Enter a name for the key vault and choose appropriate values for the Resource group, Region and Pricing tier.  
  
c. Click on the **Next** button and keep the default option for the **Permission model**, which is Azure role-based access control.  
  
d. Click on the **Review + create** button to create the new key vault.  
  
e. After the new key vault is created, go to the details page for that key vault. On the left menu select **Access control (IAM)**, and from the **Add** dropdown list, 
select the option of **Add role assignment**.  
  
   ![AddRoleAssignmentForKeyVault](${ img2 })  
  
f. Choose the **Key Vault Crypto Officer** role and click on the **Next** button.  
  
g. Choose the option of **User, group, or service principal** under **Assign access to**, and click on **Select members**. Search the service principal using the 
application name created in Step 1 above, choose the name of the application, and click on the **Select** button.  
    
h. Click on the **Review and assign** button to assign the role to the service principle.  
  
i. At the key vault details page, select **Networking** from the left menu. Choose the option of **Allow public access from specific virtual networks and IP addresses** 
under **Firewalls and virtual networks**. Under the **Firewall** section, add the public IP address of the OnData services, which is **52.249.111.17** to the whitelist.  
  
   ![KeyVaultFirewall](${ img3 })  
  
j. Select **Overview** from the left menu and save the value of **Vault URI** for later use.  
    
### Step 3: Configure Custom Key Vault at OnData Portal
a. Login to the OnData Portal as a System Administrator or Security Administrator.  
  
b. Click on the Settings icon from the top right corner and select **SecureFile**.  
  
c. Select the **Custom Key Vault** tab and check the **Enable Custom Key Vault** option.  
  
   ![CustomKeyVaultConfigure](${ img4 })  
  
d. Fill the items on the form with corresponding values from Step 1 and Step 2 above.
- Tenant Id: the value of **Directory (tenant) ID** from Step 1
- Client Id: the value of **Application (client) ID** from Step 1
- Client Secret: the value of Client Secret from Step 1
- Uri: the value of **Vault URI** from Step 2
  
e. Click on the **Save** button to enable the custom key vault. The existing encryption keys that can be exported will be automatically migrated to your key vault. 
For encryption keys that are not exportable, new keys will be created in your key vault. The encryption keys in the OnData key vault are either deleted or not used anymore.  
  
f. If you already have custom key vault configured, but decide to disable the custom key vault option, the existing encryption keys that can be exported will be 
automatically migrated to the OnData key vault. For encryption keys that are not exportable, new keys will be created in the OnData key vault. The encryption keys in your 
key vault are either deleted or not used anymore.  
  
   `
  
export default content;
